import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import {
  catchError,
  concatMap,
  debounce,
  map,
  switchMap,
  withLatestFrom,
  combineLatest,
  debounceTime, filter
} from 'rxjs/operators';
import {EMPTY, of, pipe, throwError, timer} from 'rxjs';
import { BindWifiCardActionTypes, BindWifiCardActions } from '../actions/bind-wifi-card.actions';
import {DevicesService} from '../../../services/devices.service';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import * as featureActions from '../../index';
import {updateInfoType} from '../../../shareModel';
import {UpdateInfoModel} from '../../updateInfo/update-info.model';



@Injectable()
export class BindWifiCardEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private deviceService = inject(DevicesService);

  constructor() {}

  GetBindWifiCards$ = createEffect(() => this.actions$.pipe(
    ofType(BindWifiCardActionTypes.GetBindWifiCards),
    combineLatest(this.store$.select(fromStore.getWifiCardBindingStep)),
    filter(([payload, step]) =>  step === 2),
    debounceTime(500),
    switchMap(([data, step]) => {
      if (step === 2) {
        return this.deviceService.getBindWifiCards().pipe(
          switchMap((res) => {
            if (Object.keys(res).length > 0) {
              const result = { ...res, type: updateInfoType.GetWifiCard };
              return [new featureActions.UpdateInfoSuccessAction(result), new featureActions.LoadBindWifiCards(result)];
            }
            throw new Error('No data.');
          }),
          // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
          catchError(error => {
            return of(new featureActions.GetBindWifiCardsFail(), new featureActions.GetBindWifiCards());
          })
        );
      }
      // return of(new featureActions.GetBindWifiCardsFail());
    })
  ));
  GetWifiList$ = createEffect(() => this.actions$.pipe(
    ofType(BindWifiCardActionTypes.GetWifiList),
    combineLatest(this.store$.select(fromStore.getWifiCardBindingStep)),
    filter(([payload, step]) => step === 3),
    switchMap(([data, step]) => {
      if (step === 3) {
        return this.deviceService.getWifiList().pipe(
          switchMap((res) => {
            if (res.hasOwnProperty('list')) {
              const result = { ...res, type: updateInfoType.GetWifiList };
              return [new featureActions.UpdateInfoSuccessAction(result), new featureActions.LoadWifiList(result.list)];
            }
            throw new Error('Refresh Wifi List Fail');
          }),
          // TODO: catchError Message調整 --> 已完成
          catchError(error => {
            const updateRes: UpdateInfoModel = {
              result: false,
              errmsg: 'Update Fail',
              type: updateInfoType.GetWifiList
            };
            return of(new featureActions.UpdateInfoFailAction(updateRes), new featureActions.GetWifiListFail());
          })
        );
      }
      // return of(new featureActions.GetWifiListFail());
    })
  ));
  GetConnectWifi$ = createEffect(() => this.actions$.pipe(
    ofType(BindWifiCardActionTypes.GetConnectWifi),
    map((action: any) => action.payload),
    combineLatest(this.store$.select(fromStore.getWifiCardBindingStep)),
    filter(([payload, step]) => step === 5),
    switchMap(([payload, step]) => {
      if (step === 5) {
        return this.deviceService.getConnectWifi(payload).pipe(
          map((res) => {
            if (res.result) { // Wifi card got the configuration successfully, but have not verified yet.
              return new featureActions.GetConfigWifiCardResult(); // Go to verify.
            }
            throw new Error('Config fail.');
          }),
          // TODO: catchError Message調整 --> 已完成
          catchError(error => {
            const updateRes: UpdateInfoModel = {
              result: false,
              errmsg: 'Update Fail',
              type: updateInfoType.GetConnectWifi
            };
            return of(new featureActions.UpdateInfoFailAction(updateRes));
          })
        );
      }
       return of(new featureActions.ChangStepWifiCards(0));
    })
  ));
  GetConfigWifiCardResult$ = createEffect(() => this.actions$.pipe(
    ofType(BindWifiCardActionTypes.GetConfigWifiCardResult),
    combineLatest(this.store$.select(fromStore.getWifiCardBindingStep)),
    filter(([payload, step]) => step === 5),
    debounceTime(1000),
    switchMap(([payload, step]) => {
      if (step === 5) {
        return this.deviceService.getConfigWifiCardResult().pipe(
          switchMap((res) => {
            const updateRes: UpdateInfoModel = {
              result: true,
              type: updateInfoType.GetConnectWifi
            };
            if (res.result === 0) { // Not yet finish.
              return [new featureActions.GetConfigWifiCardResult()];
            } else if (res.result === 1) { // Success
              return [new featureActions.UpdateInfoSuccessAction({ ...updateRes, msg: 'Update Success' })];
            } else if (res.result === 2) { // Fail
              return [new featureActions.UpdateInfoFailAction({ ...updateRes, result: false, errmsg: 'Update Fail' })];
            }
            throw new Error('fail');
          }),
          // TODO: catchError Message調整 --> 已完成
          catchError(error => {
            // console.log(error);
            const updateRes: UpdateInfoModel = {
              result: false,
              errmsg: 'Update Fail',
              type: updateInfoType.GetConnectWifi
            };
            return of(new featureActions.UpdateInfoFailAction(updateRes));
          })
        );
      }
      return of(new featureActions.ChangStepWifiCards(0));
    })
  ));
}
